import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addDays } from 'date-fns';
import { selectItemsAll, toggleItem } from 'utils/other';
import { DynamicOrder } from '../../utils/dynamic';
import { actionReportYieldLinkedMarketFetch } from './actions';
import { IReportYieldLinkedMarketItem, PREFIX } from './helpers';

export interface ReportYieldLinkedMarketFilters {
  date: string;
  bonds: string[];
  issuers: string[];
  branches: string[];
  equityTypeNames: string[];
  midroogRatings: string[];
  maalotRatings: string[];
  marketRatings: string[];
}

interface InitState {
  isInit: boolean;
  filters: ReportYieldLinkedMarketFilters;
  data: Array<IReportYieldLinkedMarketItem>;
  isLoading: boolean;
  isGroupByRating: boolean;
  symbols: number[];
  orderBy: DynamicOrder;
}

export const initState = (): InitState => {
  return {
    isInit: false,
    isLoading: false,
    isGroupByRating: false,
    data: [],
    filters: {
      // backend
      date: addDays(new Date(), -1).toISOString(),
      // frontend
      bonds: [],
      issuers: [],
      branches: [],
      equityTypeNames: [],
      midroogRatings: [],
      maalotRatings: [],
      marketRatings: [],
    },
    symbols: [],
    orderBy: {
      field: 'symbol',
      order: null,
    },
  };
};

const slice = createSlice({
  name: PREFIX,
  initialState: initState(),
  reducers: {
    init() {},
    destroy() {},
    setFilters(state, action: PayloadAction<ReportYieldLinkedMarketFilters>) {
      state.filters =
        state.filters.date !== action.payload.date
          ? {
              ...initState().filters,
              date: action.payload.date,
            }
          : action.payload;
    },
    toggleItem(state, action: PayloadAction<{ id: string }>) {
      toggleItem(state.data, action.payload.id);
    },
    toggleAll(state, action: PayloadAction<{ value: boolean }>) {
      selectItemsAll(state.data, action.payload);
    },
    toggleGroupByRating(state) {
      state.isGroupByRating = !state.isGroupByRating;
    },
    applySymbols(state, action: PayloadAction<number[]>) {
      state.symbols = action.payload;
    },
    setOrder(state, action: PayloadAction<DynamicOrder>) {
      state.orderBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionReportYieldLinkedMarketFetch.pending, (state, action) => {
        state.isLoading = true;
        if (action.meta.arg) {
          state.filters.date = action.meta.arg.initDate;
        }
      })
      .addCase(actionReportYieldLinkedMarketFetch.fulfilled, (state, action) => {
        state.symbols = [];
        state.data = [];

        state.isLoading = false;
        action.payload.forEach((item) => {
          state.data.push({ ...item, __isSelected: true });
          state.symbols.push(item.symbol);
        });
      })
      .addCase(actionReportYieldLinkedMarketFetch.rejected, (state, action) => {
        if (action.meta.aborted) {
          return state;
        }
        state.isLoading = false;
      });
  },
});
export const actionsReportYieldLinkedMarket = slice.actions;
export const reducerReportYieldLinkedMarket = slice.reducer;
